// eslint-disable-next-line
export const fb = firebase
fb.initializeApp({
  apiKey: 'AIzaSyCe5ppJWOh_Y5ig2TP2J8f_L7sLlhO_jgQ',
  authDomain: 'saikyo2dome-tbate.com/',
  databaseURL: 'https://saikyo2dome-prod.firebaseio.com',
  projectId: 'saikyo2dome-prod',
  storageBucket: 'saikyo2dome-prod.appspot.com',
  messagingSenderId: '559331723765',
  appId: '1:559331723765:web:ea70321b6e4dc288af78bc'
})
export const db = fb.firestore()

export function datestr (date, format) {
  format = format.replace(/Y/, date.getFullYear())
  format = format.replace(/m/, ('00' + (date.getMonth() + 1)).slice(-2))
  format = format.replace(/d/, ('00' + date.getDate()).slice(-2))
  format = format.replace(/H/, ('00' + date.getHours()).slice(-2))
  format = format.replace(/i/, ('00' + date.getMinutes()).slice(-2))
  format = format.replace(/s/, ('00' + date.getSeconds()).slice(-2))
  return format
}
datestr.date = 'Y/m/d'
datestr.dateTime = 'Y/m/d H:i'
datestr.time = 'H:i:s'
datestr.format = 'Y-m-dTH:i'

export const indexOf = (array, key, value) => {
  if (!Array.isArray(array)) {
    return false
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i][key] === value) {
      return i
    }
  }
  return -1
}

export function getDocPath (path) {
  path = path.replace(/^\//, '')
  return 'pages/' + path.split('/').join('/articles/')
}

export const getSize = b => {
  const mb = Math.floor(b / 1024 ** 2)
  if (mb) {
    return (b / 1024 ** 2).toString().slice(0, 4).replace(/\.$/, '') + 'MB'
  }
  const kb = Math.floor(b / 1024)
  if (kb) {
    return (b / 1024).toString().slice(0, 4).replace(/\.$/, '') + 'KB'
  }
  return b + 'B'
}
